module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/company-digest/customers-digest/customers-digest.component.css
// module id = ./src/app/web/game/management/company-digest/customers-digest/customers-digest.component.css
// module chunks = main